import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

// UPDATE ACTION
export const fetchUpdateAdjustmentRequest = createAsyncThunk(
  "fetchUpdateAdjustmentRequest",
  async ({ id, requestData }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("auth_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };

      const response = await axiosHttp.put(
        `adjustment-request/update/${id}`,
        requestData,
        config
      );

      message.success("Adjustment request updated successfully!");

      return response.data.data;
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || "Failed to update adjustment request";
      message.error(errorMessage);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const updateAdjustmentRequestSlice = createSlice({
  name: "updateAdjustmentRequest",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
  },
  reducers: {
    resetUpdateAdjustmentRequest: (state) => {
      state.isLoading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUpdateAdjustmentRequest.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });

    builder.addCase(fetchUpdateAdjustmentRequest.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.error = null;
    });

    builder.addCase(fetchUpdateAdjustmentRequest.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export const { resetUpdateAdjustmentRequest } = updateAdjustmentRequestSlice.actions;

export default updateAdjustmentRequestSlice.reducer;
